import {isAgent} from '@helpers/user';
import {beforeEnterRoute, pageRedirect} from "@helpers/router-helper";

const appBaseUrl = window.env?.APP_URL || '.',
    page = (page) => async () => await import(`../pages/${page}/${page}`),
    appGuard = async (to, from, next) => {
        const pages = ['partner-grant', 'partner-listings', 'partner-listings-new', 'partner-v2-login'];

        if (pages.includes(to?.name || '')) {
            return beforeEnterRoute(appBaseUrl, to, from, next, [isAgent]);
        }

        return await pageRedirect(appBaseUrl, '/not-found');
    };

export default [
    {
        path: '/partner/grant',
        name: 'partner-grant',
        component: page('PartnerGrant'),
        meta: {layout: 'Basic'},
    },
    {
        path: '/partner/listings/new',
        name: 'partner-listings-new',
        component: page('PartnerListingAdd'),
        meta: {layout: 'Basic'},
        beforeEnter: appGuard,
    },
    {
        path: '/partner/v2-login',
        name: 'partner-v2-login',
        component: page('PartnerV2Login'),
        meta: {layout: 'Basic'},
        beforeEnter: appGuard,
    },
    {
        path: '/partner/listings/:developerListingId',
        name: 'partner-listings',
        component: page('PartnerListing'),
        meta: {layout: 'Basic'},
        beforeEnter: appGuard,
    },
];
